import { Component, Input, OnInit } from '@angular/core';
import { DataManipulationService } from "../../../services/common/data-manipulation.service";

@Component({
  selector: 'app-voucher-details',
  templateUrl: './voucher-details.component.html',
  styleUrls: ['./voucher-details.component.scss']
})
export class VoucherDetailsComponent implements OnInit {

  @Input() voucher: any;
  @Input() showReservationInfo = true;
  originalVoucher: any;

  constructor(
    private dataManipulation: DataManipulationService,
  ) {
  }

  ngOnInit() {
    this.voucher.product.attachment = this.dataManipulation.oneAttachmentManipulation(this.voucher.product.attachment);
    this.dataManipulation.addNameAttributeFromFirstAndLastName(this.voucher.billingData);
    this.originalVoucher = this.getOriginalVoucherThroughHistory(this.voucher);
  }

  getOriginalVoucherThroughHistory(voucher: any) {
    let original = voucher;
    while (original.history != null) {
      original = original.history.oldVoucher;
    }
    return original;
  }

}
